function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import PropTypes from "prop-types";
import Benefit from "./benefit-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledTemplateBenefits } from "./template-benefits.scss";
const TemplateBenefits = ({ benefits, alignToCenter, translate })=>{
    if (!benefits || benefits.length === 0) return null;
    return /*#__PURE__*/ _jsxs(StyledTemplateBenefits, {
        className: classnames("template-benefits", {
            "align-center": alignToCenter
        }),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "template-benefits-main-title",
                children: translate("templateCenter.benefits.title")
            }),
            benefits === null || benefits === void 0 ? void 0 : benefits.map((benefit, index)=>/*#__PURE__*/ _jsx("div", {
                    className: "template-benefit-wrapper",
                    children: /*#__PURE__*/ _jsx(Benefit, _object_spread_props(_object_spread({}, benefit), {
                        alignToCenter: alignToCenter
                    }), `benefit_${index}`)
                }))
        ]
    });
};
TemplateBenefits.propTypes = {
    alignToCenter: PropTypes.bool,
    benefits: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string
    }))
};
TemplateBenefits.defaultProps = {
    alignToCenter: false,
    benefits: []
};
export default withGenericConfig(TemplateBenefits);
